import React, { memo, useCallback, useState } from 'react'
import KeyboardToggler from './KeyboardToggler'
import KeyboardKeys from './KeyboardKeys'
import { ToggleKeyType, AlphaCollection, NumericCollection } from './types'
import type { KeyboardProps } from './types'
import {
  FocusContext,
  useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'

const KEYBOARD_COMPONENT_FOCUS_KEY = 'KEYBOARD_COMPONENT'

const Keyboard = ({
  onArrowPress,
  onEnterPress: onEnterPressProps,
}: KeyboardProps) => {
  const { ref, focusKey } = useFocusable({
    focusKey: KEYBOARD_COMPONENT_FOCUS_KEY,
  })
  const [keyboardToggleKey, setKeyboardToggleKey] = useState(
    ToggleKeyType.alpha
  )

  const onKeyEnterPress = useCallback(
    (props: { keyString: AlphaCollection | NumericCollection }) => {
      onEnterPressProps(props.keyString)
    },
    [onEnterPressProps]
  )

  const onKeyboardToggleEnterPress = useCallback(
    (keyboardType: ToggleKeyType) => {
      setKeyboardToggleKey(keyboardType)
    },
    [setKeyboardToggleKey]
  )

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref}>
        <KeyboardToggler onEnterPress={onKeyboardToggleEnterPress} />
        <KeyboardKeys
          keyboardToggleKey={keyboardToggleKey}
          onEnterPress={onKeyEnterPress}
          onArrowPress={onArrowPress}
        />
      </div>
    </FocusContext.Provider>
  )
}

export default memo(Keyboard)
